import "../../utils/css/rightDiv.css";
import useFetchWidgets from "./useFetchWidgets";
import { CircularProgress } from "@mui/material";
import CarouselItem from "./CarouselItem";
import { isMobile } from "../../utils/miscutils";
import EmblaCarousel from "../EmblaCarousel/EmblaCarousel";

export default function Carousel({
  pageId,
  carouselId,
  itemClassnames,
  slidesToShow = 3,
  bannerOnClick = () => {},
}) {
  const { banners, loading, error } = useFetchWidgets({
    pageId,
    carouselId,
    enabled: true,
  });

  const internalSlidesToShow = isMobile(window.innerWidth)
    ? 1
    : Math.min(slidesToShow, banners.length);

  if (loading) return <CircularProgress />;
  if (error) return null;

  if (!pageId || !carouselId) {
    console.error(
      "Carousel: Both pageId and carouselId are required."
    );
    return null;
  }

  const emblaOptions = {
    loop: banners.length > internalSlidesToShow,
    align: "start",
    slidesToScroll: internalSlidesToShow,
  };

  return (
    <EmblaCarousel
      options={emblaOptions}
      autoplay={true}
      autoplayDelay={5000}
      showDots={true}
      showArrows={false}
      ariaLabel="R2C Banners"
      className="mb-carousel"
    >
      {banners.map((banner) => (
        <div
          key={banner.widgetId}
          className="embla__slide"
          style={{
            flex: `0 0 ${100 / internalSlidesToShow}%`,
          }}
        >
          <CarouselItem
            onClick={() =>
              banner.properties.onClick &&
              bannerOnClick(
                banner.properties.onClick?.value,
                pageId,
                carouselId,
                banner.altText
              )
            }
            className={itemClassnames}
            src={banner.properties.contentUrl}
            alt={banner.altText}
            ariaLabel={banner.altText}
          />
        </div>
      ))}
    </EmblaCarousel>
  );
}
